import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

export const CircleDownloadIcon = (props: Icon) => {
    const {
        color = colors.bbqBrown,
        size = 24,
        className = 'circleDownloadIcon',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            fill="none"
            viewBox="0 0 57 56"
            {...otherProps}>
            <rect
                x="1"
                y="0.5"
                width="55"
                height="55"
                rx="27.5"
                stroke="#CBBDB9"
            />
            <g clip-path="url(#clip0_7185_28233)">
                <path
                    d="M29.2169 33.5936C29.4601 33.5232 30.0617 32.928 30.2153 32.7296C31.6233 30.9376 32.4809 30.0224 33.8889 28.2368C34.3433 27.6608 34.9961 26.4768 34.3497 25.7792C33.8441 25.2288 33.0697 25.3952 32.2249 25.44L31.3417 25.408C31.3545 22.6688 31.2137 22.9632 31.1497 19.9872C31.1305 19.072 30.3177 18.3744 29.4025 18.496L28.6985 18.592C27.9049 18.7008 27.3289 19.3984 27.3737 20.1984C27.5145 22.912 27.4889 22.688 27.4761 25.2736C27.0025 25.2992 25.8441 25.2032 25.3705 25.2224C24.8265 25.248 23.9945 25.5872 24.0201 26.5088C24.0521 27.6544 26.9641 31.3216 28.0713 32.9536C28.3337 33.344 28.7689 33.7344 29.2169 33.6V33.5936Z"
                    fill={color}
                />
                <path
                    d="M39.7065 31.1295H39.2521C38.8873 31.1103 38.1385 31.4047 38.1385 31.7695C38.1385 34.8799 38.1385 34.2527 38.1513 34.5535C38.1641 35.1423 38.3241 36.5375 37.5497 36.7295L37.0249 36.7871C36.6025 36.8959 36.1737 36.8447 35.7385 36.8639C35.0025 36.8959 34.2601 36.8447 33.5241 36.8639C32.8649 36.8831 21.5945 37.0239 20.9481 36.8767C20.3273 36.7359 20.5257 36.0255 20.5257 35.4751C20.5257 34.9887 20.5257 35.3791 20.5129 31.7503C20.5129 31.3791 19.6681 31.0591 19.3353 31.0591C19.0153 31.0591 17.7993 31.3919 17.8057 31.7695C17.8441 33.9775 17.7801 37.2223 17.8505 38.0863C17.9593 39.4559 18.8745 39.7631 19.6745 39.7631C25.4601 39.7631 29.6201 40.0959 34.7337 39.9039C35.8985 39.8591 36.6665 39.8207 37.8249 39.7183C38.6697 39.6479 40.3529 39.7951 40.7241 38.7583C40.8393 38.4383 40.8393 38.0927 40.8393 37.7535C40.8393 36.4479 40.8393 35.0591 40.8393 31.7695C40.8393 31.4239 40.0457 31.1423 39.7001 31.1231L39.7065 31.1295Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_7185_28233">
                    <rect
                        width={size}
                        height={size}
                        fill="none"
                        transform="translate(12.5 12)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}
